import React from "react";

type FoundryCardProps = React.HTMLAttributes<HTMLDivElement> & {
  selected?: boolean;
};

const FoundryCard: React.FC<FoundryCardProps> = ({
  selected = false,
  className = "",
  children,
  ...props
}) => {
  return (
    <div
      {...props}
      className={[
        "rounded-xl border p-5 transition-colors",
        selected
          ? "border-orange-400 bg-orange-50 dark:border-orange-400/70 dark:bg-orange-500/10"
          : "border-slate-200 bg-white dark:border-white/10 dark:bg-slate-900",
        className,
      ].join(" ")}
    >
      {children}
    </div>
  );
};

export default FoundryCard;
